// Variants add to Cart

// document.addEventListener('DOMContentLoaded', function() {
//   var varientsRows = document.querySelectorAll('.varients__row');
//   varientsRows.forEach(function(varientsRow) {
//     varientsRow.addEventListener('click', function() {
//       var product_id = this.getAttribute('variant_id');
//       console.log('product_id', product_id);
//       var data = [];
//       console.log(data);
//       data.push({
//         'id': product_id,
//         'quantity': 1
//       });

//       var formdata = {
//         'items': data,
//         sections: ['mini-cart']
//       }
//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(formdata)
        
//       }).then((response) => {
//             return response.json();
//         }).then((result)=>{
//           var gift_header = result.sections['mini-cart'];
//           let crtDIv = document.createElement("div")
//           crtDIv.innerHTML=gift_header;
//           console.log("crtDIv" , crtDIv)
//           let tgt_old =  document.querySelector(".mini-cart");
//           console.log("tgt_old" , tgt_old)
//           let tgt_updated = crtDIv.querySelector(".mini-cart")
//           tgt_old.innerHTML=tgt_updated.innerHTML
//         })
//       document.getElementById("cart-icon-bubble").click();
//     });
//   });
// });


//  document.querySelectorAll(".add_btn").forEach(item => {
//   item.addEventListener("click", function() {
//     let toToggle =  item.parentElement.previousElementSibling
//     if( toToggle.style.display == "flex") {
//       toToggle.style.display = "none"
//     } else {
//       document.querySelectorAll(".add_btn").forEach(element => {
//         element.parentElement.previousElementSibling.style.display ="none"
//       })
//         item.parentElement.previousElementSibling.style.display = "grid"     
//     }
//   });
// });
//   document.querySelectorAll(".cross_btn").forEach(item => {
//     item.addEventListener('click',function(e) {
//     console.log("ll" , e.target.parentElement.style.display="none")
//   });
// });

// tab

   let btn1 = document.getElementById('btn1');
        btn1.style.borderBottom='5px solid #d5b375';
        let tab1 = document.getElementById('tab1');
        let tab2 = document.getElementById('tab2');
        btn1.addEventListener('click', function() {
            tab1.style.display='grid';
            tab2.style.display='none';
            btn1.style.borderBottom='5px solid #d5b375';
            btn2.style.borderBottom='5px solid #ddd';
            btn2.style.color='#000';
        }) 
        let btn2 = document.getElementById('btn2');
        btn2.addEventListener('click', function() {
           tab1.style.display='none';
           tab2.style.display='grid';
           btn1.style.borderBottom='5px solid #ddd';
           btn2.style.borderBottom='5px solid #d5b375';
        }) 